import { TRIPLE, SEXTUPLE } from "../../../constants/numbers.consts.js";
export const headerSx = {
    overflow: "clip",
    padding: ({ spacing }) => spacing(TRIPLE, SEXTUPLE),
};
export const footerSx = {
    minHeight: 73,
    width: "100%",
    overflow: "clip",
    marginTop: "auto",
    display: "grid",
    alignContent: "center",
    borderTop: ({ vars }) => `solid thin ${vars.palette.surface.variant}`,
    padding: ({ spacing }) => spacing(SEXTUPLE),
};
